import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { BrManageContentButton, BrManageMenuButton } from '@bloomreach/react-sdk';
import { Footer, FooterLinks } from '@grandvisionhq/layout';
import { RuntimeContext } from '../../runtime-context.js';
import { useBloomreach, useBrPageContext, useBrComponentContext } from '../../context/context.js';
import { useBloomreachNewsletterData } from '../../hooks/use-bloomreach-newsletter-data.js';
import { createMenu } from '../../utils/create-menu.js';

const CmsFooter = ({ useAlternativeLogoInFooter =true  })=>{
    var ref, ref1;
    const { site  } = React.useContext(RuntimeContext);
    const { siteLogos  } = useBloomreach();
    const page = useBrPageContext();
    const component = useBrComponentContext();
    const newsletterData = useBloomreachNewsletterData();
    const preview = page === null || page === void 0 ? void 0 : page.isPreview();
    var ref2;
    const siteName = (ref2 = site === null || site === void 0 ? void 0 : site.name) !== null && ref2 !== void 0 ? ref2 : 'Unknown';
    const fallbackLogo = useAlternativeLogoInFooter ? siteLogos.alternative : siteLogos.main;
    const logo = {
        url: siteLogos.logoFooter || fallbackLogo,
        altText: siteName
    };
    if (!page || !component) {
        return null;
    }
    // Footer content
    const { document: documentRef  } = component.getModels();
    const document = page.getContent(documentRef);
    const content = document === null || document === void 0 ? void 0 : document.getData();
    // Footer bottom menu
    const menuDocument = ((ref = component.getComponent('menu')) === null || ref === void 0 ? void 0 : ref.getModels()) || {};
    const menuItems = createMenu(menuDocument, page);
    const newsletterProps = swcHelpers.objectSpread({}, newsletterData, {
        modalButtonTitle: content === null || content === void 0 ? void 0 : (ref1 = content.newsletterModal) === null || ref1 === void 0 ? void 0 : ref1.modalButtonTitle
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, preview && document && /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(BrManageContentButton, {
        content: document
    })), content && /*#__PURE__*/ React.createElement(Footer, swcHelpers.extends({}, content, {
        logo: logo,
        newsletterProps: newsletterProps,
        siteName: siteName
    }), (menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, preview && menuDocument.menu && /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(BrManageMenuButton, {
        menu: menuDocument.menu
    })), /*#__PURE__*/ React.createElement(FooterLinks, {
        items: menuItems
    }))));
};
var CmsFooter$1 = CmsFooter;

export { CmsFooter, CmsFooter$1 as default };
//# sourceMappingURL=Footer.js.map
